import { render, staticRenderFns } from "./SingleNumberChart.vue?vue&type=template&id=ee5f538e&"
import script from "./SingleNumberChart.vue?vue&type=script&lang=js&"
export * from "./SingleNumberChart.vue?vue&type=script&lang=js&"
import style0 from "./SingleNumberChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
